import "./styles.css";

import PartySocket from "partysocket";

declare const PARTYKIT_HOST: string;

let pingInterval: ReturnType<typeof setInterval>;

// Try to get user ID
const getUserId = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('userId') || localStorage.getItem('userId');
};

// Let's append all the messages we get into this DOM element
const output = document.getElementById("app") as HTMLDivElement;

// Helper function to add a new line to the DOM
function add(text: string) {
  output.appendChild(document.createTextNode(text));
  output.appendChild(document.createElement("br"));
}

// A PartySocket is like a WebSocket, except it's a bit more magical.
// It handles reconnection logic, buffering messages while it's offline, and more.
const conn = new PartySocket({
  host: PARTYKIT_HOST,
  party: "channel",
  room: getUserId() || "my-new-room",
});

// You can even start sending messages before the connection is open!
conn.addEventListener("message", (event) => {
  add(`Received -> ${event.data}`);
});

// Reduced ping frequency from 2 seconds to 30 seconds
conn.addEventListener("open", () => {
  add("Connected!");
  add("Sending a ping every 30 seconds...");
  clearInterval(pingInterval);
  pingInterval = setInterval(() => {
    conn.send("ping");
  }, 30000);
});

// Clean up interval on connection close
conn.addEventListener("close", () => {
  add("Disconnected!");
  clearInterval(pingInterval);
});

// Handle reconnection
conn.addEventListener("error", (error) => {
  add(`Connection error: ${error}`);
});
